import React from 'react'
import PropTypes from 'prop-types'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import {
  ContextMenuListItem,
  Popover,
} from '../../../../../components/common/Dialogs/Popover'
import Typography from '../../../../../components/common/Typography'
import usePopover from '../../../../../hooks/usePopover'
import {
  EMAILING_FREQUENCY_OPTIONS,
  getEmailingFrequencyOption,
  getEmailingFrequencyOptionValue,
} from '../../../../../utils/savedSearchesUtils'
import styles from './styles.module.css'

export default function EmailingFrequencySelect({
  userDetail,
  onChange,
  disabled,
}) {
  const [anchorEl, onOpen, onClose] = usePopover()
  const value = getEmailingFrequencyOptionValue(userDetail)
  const selected = getEmailingFrequencyOption(value)

  const handleSelect = option => {
    if (typeof onChange === 'function') {
      onChange(option)
    }
    onClose()
  }

  return (
    <>
      <button
        type="button"
        className={styles.emailingSelectButton}
        disabled={disabled}
        onClick={disabled ? undefined : onOpen}
      >
        <Typography variant="body2" component="span" weight="500">
          {selected?.label}
        </Typography>
        <ArrowDropDownIcon fontSize="small" />
      </button>

      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose}>
        {EMAILING_FREQUENCY_OPTIONS.map(option => (
          <ContextMenuListItem
            key={option.value}
            button
            size="normal"
            selected={option.value === value}
            onClick={() => handleSelect(option)}
          >
            <Typography variant="body2" weight="500">
              {option.label}
            </Typography>
          </ContextMenuListItem>
        ))}
      </Popover>
    </>
  )
}

EmailingFrequencySelect.propTypes = {
  userDetail: PropTypes.shape({
    savedSearchTypeNotices: PropTypes.string,
    consolidateNotificationSelect: PropTypes.string,
    consolidateNotificationNumber: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}
